export default function Location(props) {
  return (
    <svg width='27.98' height='40' viewBox='0 0 27.98 40' fill='#fff' {...props}>
      <path d='M13.991,18.967a4.969,4.969,0,0,0,4.977-4.977,4.969,4.969,0,0,0-4.977-4.977,4.969,4.969,0,0,0-4.977,4.977,4.969,4.969,0,0,0,4.977,4.977ZM13.991,0A13.489,13.489,0,0,1,23.9,4.085a13.489,13.489,0,0,1,4.085,9.906,18.777,18.777,0,0,1-1.455,6.667A41.1,41.1,0,0,1,23,27.7q-2.066,3.286-4.085,6.15T15.493,38.4l-1.5,1.6q-.563-.657-1.5-1.737t-3.38-4.319a72.368,72.368,0,0,1-4.272-6.291,45.689,45.689,0,0,1-3.333-6.9A19,19,0,0,1,0,13.991,13.489,13.489,0,0,1,4.085,4.085,13.489,13.489,0,0,1,13.991,0Z' />
    </svg>
  )
}
